import ResultRoundItem, { ResultRoundItemProps } from './ResultRoundItem';

export default ResultRoundItem;
export type { ResultRoundItemProps };
